import React from 'react';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { WhiteModal, MEDIA_QUERIES } from '@sm360/widget-commons-general';

import ResetPasswordContent from 'login/components/ResetPassword/ResetPasswordContent/ResetPasswordContent.jsx';
import MediaQuery from 'react-responsive';

import { RESET_PASSWORD as MODAL } from 'login/constants/modalNames.js';

const czGroupName = 'widget.login.forms.resetpassword';

const ResetPasswordModal = () => {
    const modalBackgroundImageUrl =
        ContentZonesService.getContentZone(czGroupName, 'background') &&
        ContentZonesService.getContentZone(czGroupName, 'background').getValue();

    return (
        <WhiteModal
            name={MODAL}
            contentLabel="dialog with form for Sign in"
            className="widget-login-popupElement"
            isScrollable
            isClosable
            backgroundImage={modalBackgroundImageUrl}
        >
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <ResetPasswordContent className="is-scrollable" />
            </MediaQuery>
            <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                <ResetPasswordContent />
            </MediaQuery>
        </WhiteModal>
    );
};

ResetPasswordModal.displayName = 'ResetPasswordModal';

export default ResetPasswordModal;
